import React, { useEffect, useState } from 'react'
import { GrMail } from 'react-icons/gr'
import { IoIosCall } from 'react-icons/io'
import { MdOutlineKeyboardArrowDown } from 'react-icons/md'
import {
  FaLinkedinIn,
  FaFacebookF,
  FaUser,
  FaLock,
  FaList,
  FaHome,
  FaStore,
  FaInfoCircle,
  FaRegNewspaper
} from 'react-icons/fa'
import {
  AiOutlineTwitter,
  AiFillGithub,
  AiFillHeart,
  AiFillShopping,
  AiOutlineSearch
} from 'react-icons/ai'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { get_card_products, get_wishlist_products } from '../store/reducers/cardReducer'
import { fetchProfile } from '../store/reducers/profileSlice'

const Headers = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const { userInfo } = useSelector((state) => state.auth)
  const profile = useSelector((state) => state.profile.user)
  const profileStatus = useSelector((state) => state.profile.status)
  const { card_product_count, wishlist_count } = useSelector((state) => state.card)

  const [showSidebar, setShowSidebar] = useState(false)
  const [hideHeader, setHideHeader] = useState(false)
  const [lastScrollY, setLastScrollY] = useState(0)
  const [hidePosition, setHidePosition] = useState(0)

  const downHideThreshold = 240
  const upShowDelta = 90

  useEffect(() => {
    if (userInfo) {
      dispatch(fetchProfile())
      dispatch(get_card_products(userInfo.id))
      dispatch(get_wishlist_products(userInfo.id))
    }
  }, [dispatch, userInfo])

  useEffect(() => {
    const handleScroll = () => {
      const y = window.scrollY
      if (y > downHideThreshold && y > lastScrollY) {
        setHideHeader(true)
        setHidePosition(y)
      } else if (hideHeader && y < hidePosition - upShowDelta) {
        setHideHeader(false)
      }
      setLastScrollY(y)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [hideHeader, lastScrollY, hidePosition])

  const redirectCardPage = () => {
    if (userInfo) navigate('/card')
    else navigate('/login')
  }

  const displayName =
    profileStatus === 'succeeded' && profile?.name
      ? profile.name
      : userInfo?.name || ''

  return (
    <div className="w-full z-50">
      {/* HEADER (slides away on scroll) */}
      <div
        className={`fixed top-0 left-0 w-full z-50 bg-white shadow transition-transform duration-500 ${
          hideHeader ? '-translate-y-[110px]' : 'translate-y-0'
        }`}
      >
        {/* — TOP BAR — */}
        <div className="bg-gray-100 py-2">
          <div className="container mx-auto px-4 flex items-center justify-between text-gray-600 text-sm">
            <div className="flex items-center gap-2">
              <GrMail />
              <span className="text-xs">TrendStreet@gmail.com</span>
            </div>
            <div className="flex items-center gap-4">
              <div className="flex gap-2">
                <a href="#"><FaFacebookF /></a>
                <a href="#"><AiOutlineTwitter /></a>
                <a href="#"><FaLinkedinIn /></a>
                <a href="#"><AiFillGithub /></a>
              </div>
              <div className="flex items-center gap-1 group relative cursor-pointer text-xs text-gray-600">
                <img
                  src="https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg"
                  alt="lang"
                  className="w-4 h-4"
                />
                <MdOutlineKeyboardArrowDown />
                <ul className="invisible opacity-0 group-hover:visible group-hover:opacity-100 absolute top-6 left-0 bg-black text-white text-sm rounded-sm p-2 z-10 transition duration-200">
                  <li className="px-2 py-1 hover:bg-gray-600">English</li>
                  <li className="px-2 py-1 hover:bg-gray-600">Bangla</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* — MAIN ROW — */}
        <div className="w-[85%] lg:w-[90%] mx-auto h-[80px] flex justify-between items-center">
          {/* — LEFT: list icon + cart icon — */}
          <div className="flex items-center gap-3">
            <div
              className="w-[30px] h-[30px] bg-white text-slate-700 rounded-sm cursor-pointer p-1.5 lg:hidden md:flex"
              onClick={() => setShowSidebar(true)}
            >
              <FaList />
            </div>

            <div
              onClick={redirectCardPage}
              className="relative flex justify-center items-center cursor-pointer w-[35px] h-[35px] rounded-full bg-[#e2e2e2]"
            >
              <AiFillShopping className="text-xl text-orange-500" />
              {card_product_count > 0 && (
                <div className="absolute -top-[3px] -right-[5px] w-[20px] h-[20px] bg-green-500 rounded-full text-white text-xs flex items-center justify-center">
                  {card_product_count}
                </div>
              )}
            </div>
          </div>

          {/* — CENTER: logo — */}
          <div className="flex-1 flex justify-center">
            <Link to="/">
              <img
                src="/images/logo2.png"
                alt="TrendStreet"
                style={{ height: '60px', objectFit: 'contain' }}
              />
            </Link>
          </div>

          {/* — RIGHT: heart + static search icon — */}
          <div className="flex items-center gap-4">
            <div
              onClick={() => navigate(userInfo ? '/dashboard/my-wishlist' : '/login')}
              className="relative flex justify-center items-center cursor-pointer w-[35px] h-[35px] rounded-full bg-[#e2e2e2]"
            >
              <AiFillHeart className="text-xl text-red-500" />
              {wishlist_count > 0 && (
                <div className="absolute -top-[3px] -right-[5px] w-[20px] h-[20px] bg-green-500 rounded-full text-white text-xs flex items-center justify-center">
                  {wishlist_count}
                </div>
              )}
            </div>

           <div
              className="cursor-pointer text-2xl text-gray-600"
              onClick={() => navigate('/search')}
            >
              <AiOutlineSearch />
            </div>
          </div>
        </div>
      </div>

      {/* spacer to compensate header height */}
      <div style={{ height: '80px' }} />

      {/* — MOBILE SIDEBAR — */}
      <div className="hidden md:block">
        <div
          onClick={() => setShowSidebar(false)}
          className={`fixed duration-200 transition-all ${
            showSidebar ? 'visible' : 'invisible'
          } w-screen h-screen bg-[rgba(0,0,0,0.5)] top-0 left-0 z-40`}
        />
        <div
          className={`w-[300px] fixed top-0 h-screen py-6 px-8 bg-white z-[9999] transition-all duration-200 ${
            showSidebar ? 'left-0' : '-left-[300px]'
          } overflow-y-auto`}
        >
          <div className="flex flex-col gap-6 min-w-min">
            <Link to="/">
              <img src="/images/logo2.png" alt="logo" className='w-20' />
            </Link>

            <ul className="flex flex-col gap-2 text-md font-semibold uppercase">
              {userInfo ? (
                <li>
                  <Link
                    to="/dashboard"
                    className={`py-2 flex items-center gap-2 ${
                      pathname === '/dashboard'
                        ? 'text-[#7fad39]'
                        : 'text-slate-600'
                    }`}
                  >
                    <FaUser className="text-xl" />
                    <span>{displayName}'s Dashboard</span>
                  </Link>
                </li>
              ) : (
                <li>
                  <Link
                    to="/login"
                    className={`py-2 flex items-center gap-2 ${
                      pathname === '/login'
                        ? 'text-[#7fad39]'
                        : 'text-slate-600'
                    }`}
                  >
                    <FaLock />
                    <span>Login</span>
                  </Link>
                </li>
              )}

              <li>
                <Link
                  to="/"
                  className={`py-2 flex items-center gap-2 ${
                    pathname === '/' ? 'text-[#7fad39]' : 'text-slate-600'
                  }`}
                >
                  <FaHome />
                  <span>Home</span>
                </Link>
              </li>

              <li>
                <Link
                  to="/shops"
                  className={`py-2 flex items-center gap-2 ${
                    pathname === '/shops' ? 'text-[#7fad39]' : 'text-slate-600'
                  }`}
                >
                  <FaStore />
                  <span>Shop</span>
                </Link>
              </li>

              <li>
                <Link
                  to="/blog"
                  className={`py-2 flex items-center gap-2 ${
                    pathname === '/blog' ? 'text-[#7fad39]' : 'text-slate-600'
                  }`}
                >
                  <FaRegNewspaper />
                  <span>Blog</span>
                </Link>
              </li>

              <li>
                <Link
                  to="/aboutus"
                  className={`py-2 flex items-center gap-2 ${
                    pathname === '/aboutus' ? 'text-[#7fad39]' : 'text-slate-600'
                  }`}
                >
                  <FaInfoCircle />
                  <span>About</span>
                </Link>
              </li>

              <li>
                <Link
                  to="/contact"
                  className={`py-2 flex items-center gap-2 ${
                    pathname === '/contact' ? 'text-[#7fad39]' : 'text-slate-600'
                  }`}
                >
                  <IoIosCall />
                  <span>Contact</span>
                </Link>
              </li>
            </ul>

            <div className="flex gap-4">
              <a href="#"><FaFacebookF /></a>
              <a href="#"><AiOutlineTwitter /></a>
              <a href="#"><FaLinkedinIn /></a>
              <a href="#"><AiFillGithub /></a>
            </div>

            <div className="flex items-center gap-3">
              <div className="w-[48px] h-[48px] rounded-full bg-[#f5f5f5] flex justify-center items-center">
                <IoIosCall />
              </div>
              <div>
                <h2 className="text-sm font-medium text-slate-700">+12345678901</h2>
                <span className="text-xs">support 33/45 time</span>
              </div>
            </div>

            <ul className="flex flex-col gap-3 text-[#1c1c1c]">
              <li className="flex items-center gap-2 text-sm">
                <GrMail /><span>TrendStreet@gmail.com</span>
              </li>
              <span className="text-sm">Multi vendor ecommerce</span>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Headers